import { getGetterTypesForService } from 'shared/utils/createServiceStore.js';
import { TUNNEL_SERVICE_KEY } from './tunnelEnum.js';

export default getGetterTypesForService(TUNNEL_SERVICE_KEY);
